import { jsx as o, jsxs as w } from "react/jsx-runtime";
import { forwardRef as C, useRef as N, useEffect as p } from "react";
import { c as W } from "./clsx-OuTLNxxd.js";
import { B as H } from "./Button-DQ5ID5KN.js";
import { C as D } from "./Cross-jbk27eUQ.js";
const F = "320px", E = "600px", V = "1025px", j = "_isVisuallyHidden_2gcc1_51", L = "_dialog_2gcc1_63", M = "_hasBackdrop_2gcc1_77", P = "_isFullScreen_2gcc1_80", T = "_closeButtonWrapper_2gcc1_89", X = "_dialogWrapper_2gcc1_102", Y = "_panel_2gcc1_116", e = {
  mobile: F,
  "mobile-wide": "480px",
  tablet: E,
  "tablet-wide": "800px",
  desktop: V,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  isVisuallyHidden: j,
  dialog: L,
  hasBackdrop: M,
  isFullScreen: P,
  closeButtonWrapper: T,
  dialogWrapper: X,
  panel: Y
}, b = ({
  children: n,
  className: c,
  isOpen: t = !1,
  isFullScreen: s = !1,
  setIsOpen: r,
  shouldCloseOnClickOutside: B = !0,
  hasBackdrop: S = !0,
  triggerRef: x,
  title: d,
  ..._
}) => {
  const l = N(null), a = (i) => {
    var m, u;
    if (!B)
      return;
    const z = (m = l.current) == null ? void 0 : m.getBoundingClientRect(), { top: g = 0, bottom: y = 0, left: f = 0, right: h = 0 } = z || {};
    if (g === 0 && y === 0 && f === 0 && h === 0)
      return;
    const k = i.clientY < g || i.clientY > y || i.clientX < f || i.clientX > h;
    t && !((u = x == null ? void 0 : x.current) != null && u.contains(i == null ? void 0 : i.target)) && k && r(!1);
  };
  return p(() => {
    l.current && (t ? l.current.showModal() : l.current.close());
  }, [l, t]), p(() => {
    if (!(typeof window > "u"))
      return document.addEventListener("click", a), () => {
        document.removeEventListener("click", a);
      };
  }, [a]), /* @__PURE__ */ w(
    "dialog",
    {
      id: "cxy-dialog",
      ref: l,
      "aria-label": `${d}-modal`,
      className: W(
        e.dialog,
        { [e.hasBackdrop]: S },
        { [e.isFullScreen]: s },
        c
      ),
      ..._,
      children: [
        /* @__PURE__ */ o("div", { className: e.closeButtonWrapper, children: /* @__PURE__ */ o(
          H,
          {
            variant: "ghost",
            "data-testid": "close-button",
            className: e.closeButton,
            onClick: () => r(!1),
            "aria-label": `Close ${d} Modal`,
            children: /* @__PURE__ */ o(D, { size: "xl" })
          }
        ) }),
        /* @__PURE__ */ o("div", { className: e.dialogWrapper, children: n })
      ]
    }
  );
}, $ = ({
  children: n,
  className: c,
  ...t
}) => /* @__PURE__ */ o("section", { className: W(e.panel, c), ...t, children: /* @__PURE__ */ o("div", { className: e.panelWrapper, children: n }) }), q = C(
  ({ children: n, onClick: c, ...t }, s) => /* @__PURE__ */ o(H, { variant: "ghost", onClick: c, ref: s, ...t, children: n })
);
b.Panel = $;
b.Trigger = q;
export {
  b as D
};
